module.exports = __webpack_public_path__ + "static/media/bed.138c8828.svg";